import { Alert, Button, Card, Collapse } from "antd";
import React, { useState } from "react";
import Backgrounds from "../globals/styles/Backgrounds";
import Colours from "../globals/styles/Colours";
import Links from "../globals/styles/Links";
import MetaSharing from "../globals/styles/MetaSharing";
import SiteText from "../globals/styles/SiteText";
import StyleButtons from "../globals/styles/StyleButtons";
import StyleContents from "../globals/styles/StyleContents";
import Templates from "../globals/styles/Templates";
import { usePrefs } from "../utils/Prefs";
import { scope } from "../data.js";
import { useTemplate } from "../utils/Template";
import Fonts from "../globals/styles/Fonts";
import Save from "../globals/Save";
import LinkStyles from "../globals/styles/LinkStyles.js";
export default function StylesPanel(props) {

    const [template, setTemplate] = useTemplate();
    const [templates, setTemplates] = useState(props.templates);
    const [data, setData] = useState(template);
    const [prefs, setPrefs] = usePrefs();

    const updateData = (_data = {}, changed = true) => {
        setData(_data);
    }

    // Overflow the header so clicking the caret opens / closes the menu
    const cssAdjust = {
        marginLeft : "-30px",
        paddingLeft : "30px",
        position : "relative",
        zIndex : 10
    }

    // Custom header interaction to limit keyboard toggling on modals
    const drawHeader = (_label = "", _key = 0) => {
        return(
            <div style={{...cssAdjust}} onClick={() => {
                // close if already opened
                let _k = (prefs.style_index === _key) ? 0 : _key;
                setPrefs({...prefs, "style_index" : _k })
            }}>
            <strong>{_label}</strong>
            </div>
        )
    }


    return (
        <>
            <div style={{"position" : "fixed", "zIndex" : "11", "backgroundColor" : "#fafafa", "width" : "300px", "marginTop" : "-10px"}}>
                <div style={{"padding" : "5px 10px", "backgroundColor" : "#fafafa", "borderBottom" : "1px solid #d9d9d9"}}>
                   <Save templates={templates} />
                    <div className="shim" />
                </div>
            </div>
            <div style={{"height" : "35px"}}></div>
           
            <Collapse activeKey={prefs.style_index} accordion style={{ border: "none", width: "300px" }}>
                
                
                <Collapse.Panel key={2} header={drawHeader("Colours", 2)}>
                    <Colours templates={templates} changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={3} header={drawHeader("Fonts", 3)} extra={(prefs.style_index !== 3) ? <></> : <Fonts view="header" changed={prefs.changed} setData={setTemplate} data={template} />}>
                    <Fonts templates={templates} changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={8} header={drawHeader("Text Presets", 8)} extra={(prefs.style_index !== 8) ? <></> : <StyleContents view="header" changed={prefs.changed} setData={setTemplate} data={template} />}>
                <Alert style={{"lineHeight" : "10px", "marginBottom" : "10px"}} closable description={<div style={{"lineHeight" : "14px"}}><small>Content Components utilize Text Presets to style text. Create a handful of text styles that can be selected within various Content Components, which will keep text styling consistent across your site. If a change is made to a Text Preset, all components using that preset will be updated with those changes.</small></div>} />
                    <StyleContents templates={templates} changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={4} header={drawHeader("Buttons", 4)} extra={(prefs.style_index !== 4) ? <></> : <StyleButtons view="header" changed={prefs.changed} setData={setTemplate} data={template} />}>
                    <StyleButtons templates={templates} changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={5} header={drawHeader("Site Text", 5)}>
                <Alert style={{"lineHeight" : "10px", "marginBottom" : "10px"}} closable description={<div style={{"lineHeight" : "14px"}}><small>This will change the font used for all the text in each Content Component that doesn't have a Text or Button Preset assigned, the site header/navigation bar text, and site footer text. It's also the default font for all new text and button presets.</small></div>} />
                    <SiteText setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={6} header={drawHeader("Link Styles", 6)} extra={(prefs.style_index !== 6) ? <></> : <LinkStyles view="header" changed={prefs.changed} setData={setTemplate} data={template} />}>
                    <LinkStyles templates={templates} changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel>

                {/* <Collapse.Panel key={6} header={drawHeader("Links", 6)}>
                <Alert style={{"lineHeight" : "10px", "marginBottom" : "10px"}} closable description={<div style={{"lineHeight" : "14px"}}><small>Initial styling is what hyperlinks on your webstore will look like before they are hovered over or placed in focus. We recommend adding some stylistic differences for the Hover / Focus state so users can intuit the text as a link, and for those navigating your site using accessibility aids or only their keyboard.</small></div>} />
                    <Links setData={setTemplate} data={template} />
                </Collapse.Panel> */}

                <Collapse.Panel key={7} header={drawHeader("Backgrounds", 7)}>
                    <Backgrounds setData={setTemplate} data={template} />
                </Collapse.Panel>

                <Collapse.Panel key={1} header={drawHeader("Templates", 1)} extra={(prefs.style_index !== 1) ? <></> : <Templates templates={templates} setTemplates={setTemplates} view="header" changed={prefs.changed} setData={setTemplates} data={data} />}>
                <Alert style={{"lineHeight" : "10px", "marginBottom" : "10px"}} type="error" closable description={<div style={{"lineHeight" : "14px"}}><small><strong>Please read the <a target="_blank" href="https://support.bookmanager.com/tutorials/webstore-designer/styles-tab/templates/#what-is-a-template">documentaiton</a> before creating new templates. </strong><br /><br /> Modify an existing or create a new template, then use the <strong>Eye</strong> button to activate it on your live Webstore. If you are modifying an activated template (the Eye is green), changes will be live after saving.</small></div>} />
                    <Templates templates={templates} setTemplates={setTemplates} changed={prefs.changed} setData={setTemplates} data={data} />
                </Collapse.Panel>


               

                {/* <Collapse.Panel key={9} header={drawHeader("Meta sharing", 9)}>
                    <MetaSharing changed={prefs.changed} setData={setTemplate} data={template} />
                </Collapse.Panel> */}

            </Collapse>
        </>
    )
}